import React from 'react';
import { useContent } from '../../hooks/useContent';
import LoadingSpinner from '../common/LoadingSpinner';
import ErrorMessage from '../common/ErrorMessage';

const FaqSection = () => {
    const { content, isLoading, isError, error, loadContentBySection } = useContent('faq');

    // Get the FAQ content data
    const faqData = content.length > 0 ? content[0].content_data : null;

    if (isLoading) {
        return (
            <section className="section faq-area style-two ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <LoadingSpinner size="lg" />
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (isError) {
        return (
            <section className="section faq-area style-two ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <ErrorMessage error={error} onRetry={() => loadContentBySection('faq')} />
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (!faqData) {
        return (
            <section className="section faq-area style-two ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="text-center">
                                <p>No FAQ content available.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="section faq-area style-two ptb_100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-10 col-lg-8">
                        {/* Section Heading */}
                        <div className="section-heading text-center">
                            <h2 className="text-capitalize">{faqData.heading}</h2>
                            <p className="d-none d-sm-block mt-4">{faqData.headingText}</p>
                            <p className="d-block d-sm-none mt-4">{faqData.headingTexttwo}</p>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-12">
                        {/* FAQ Content */}
                        <div className="faq-content">
                            {/* SalesPinch Accordion */}
                            <div className="accordion" id="SalesPinch-accordion">
                                <div className="row justify-content-center">
                                    <div className="col-12 col-md-6">
                                        {/* Single Card */}
                                        {faqData.faqData && faqData.faqData.map((item, idx) => (
                                            <div key={`fo_${idx}`} className="card border-0">
                                                {/* Card Header */}
                                                <div className="card-header bg-inherit border-0 p-0">
                                                    <h2 className="mb-0">
                                                        <button className="btn px-0 py-2" type="button">
                                                            {item.title}
                                                        </button>
                                                    </h2>
                                                </div>
                                                {/* Card Body */}
                                                <div className="card-body px-0 py-3">
                                                    {item.content}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="col-12 col-md-6">
                                        {/* Single Card */}
                                        {faqData.faqDataTwo && faqData.faqDataTwo.map((item, idx) => (
                                            <div key={`ft_${idx}`} className="card border-0">
                                                {/* Card Header */}
                                                <div className="card-header bg-inherit border-0 p-0">
                                                    <h2 className="mb-0">
                                                        <button className="btn px-0 py-2" type="button">
                                                            {item.title}
                                                        </button>
                                                    </h2>
                                                </div>
                                                {/* Card Body */}
                                                <div className="card-body px-0 py-3">
                                                    {item.content}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="row justify-content-center">
                                    <p className="text-body text-center pt-4 fw-5">
                                        {faqData.faqText} <a href="/contact-page">{faqData.faqTextLink}</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FaqSection;